export enum ServiceType {
    TWITTER,
	INSTAGRAM, 
	FACEBOOK,
	APN
  }